import {noop} from '@sail/utils';
import {createContext} from 'react';

export default createContext<() => void>(noop);
